import type { Chart, ChartType, TooltipModel } from 'chart.js'
interface Context<TType extends ChartType> {
  chart: Chart
  tooltip: TooltipModel<TType>
}

export const summaryCustomTooltip = (context: Context<'bar'>, dataTypeName: string): void => {
  let tooltipEl = document.getElementById('chartjs-tooltip')
  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.id = 'chartjs-tooltip'
    tooltipEl.innerHTML =
      '<div style="position: relative; font-family: Hiragino Kaku Gothic Pro; font-size: 10px;">' +
      '<div style="position: absolute; top: 35px; left: -14px; margin-top: -12px; border: 6px solid transparent; border-right: 8px solid rgba(0, 0, 0, 0.8);">' +
      '</div>' +
      '<table style="background-color: rgba(0, 0, 0, 0.8); padding: 4px 12px; border-radius: 8px;"></table></div>'
    document.body.appendChild(tooltipEl)
  }
  const tooltipModel = context.tooltip
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.display = 'none'
    return
  }
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  tooltipEl.classList.add(tooltipModel.yAlign || 'no-transform')

  let innerHtml = '<thead>'
  innerHtml += '</thead><tbody style="color: white;">'
  innerHtml += '<tr><td style="font-weight: bold;">' + tooltipModel.title[0] + '</td></tr>'
  if (tooltipModel.dataPoints[0].dataset.label !== undefined) {
    innerHtml += '<tr><td >' + tooltipModel.dataPoints[0].dataset.label[0] + '</td></tr>'
  }
  let sum = 0
  tooltipModel.dataPoints.forEach(dataPoint => sum += dataPoint.parsed.y)
  innerHtml += '<tr><td style="font-weight: bold;">' + `${dataTypeName} : ${sum.toLocaleString()}件` + '</td></tr>'
  tooltipModel.dataPoints.reverse().forEach(dataPoint => {
    let label = ''
    if (dataPoint.dataset.label !== undefined) {
      label = dataPoint.dataset.label[1]
    }
    innerHtml += `<tr><td><div style="background-color: ${dataPoint.dataset.backgroundColor}; aspect-ratio: 1; width: 10px; display: inline-block; border: solid 0.5px white; position:relative; top: 2px; margin-right: 4px;"></div>` + label + ' : ' + Number(dataPoint.parsed.y).toLocaleString() + '件' + '</td></tr>'
  })
  innerHtml += '</tbody>'
  const tableRoot = tooltipEl.querySelector('table')
  if (tableRoot) {
    tableRoot.innerHTML = innerHtml
  }
  const position = context.chart.canvas.getBoundingClientRect()
  tooltipEl.style.display = 'block'
  tooltipEl.style.position = 'absolute'
  tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 15 + 'px'
  tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - 30 + 'px'
}
